import React from 'react'
import { Box, Container, Stack } from '@mantine/core'

import { FooterWrapper } from 'components/site'

import Header from './Header'
import ContactUs from './ContactUs'
import FeatureCompare from './FeatureCompare'
import { Product } from 'types/domain'
import { ProductsModalContent } from 'components/business/ProductsModal'

type Props = {
  products: Product[]
}
const Pricing = ({ products }: Props) => {
  return (
    <Stack spacing={0} className="overflow-x-hidden xs:overflow-x-visible pt-[0]">
      <Header />
      <Container className="mt-[-356px] sm:mt-[-170px] sm:max-w-[1200px] m-[unset] sm:m-[auto]">
        <ProductsModalContent fromSite products={products} />
      </Container>
      <Box className="hidden sm:block">
        <ContactUs />
        <FeatureCompare products={products} />
      </Box>
      <FooterWrapper className="pt-[96px] !bg-[center_top_-40px]" />
    </Stack>
  )
}

export default Pricing
